import { useMemo } from "react";

import usePricing from "common/datahooks/usePricing";
import type { PricingPeriodUnit, SubscriptionType } from "common/types";

export default function useSubscriptionPricing(
  periodUnit: PricingPeriodUnit,
  type: SubscriptionType,
) {
  const { pricing, isLoadingPricing } = usePricing();

  const license = useMemo(
    () =>
      pricing?.find(
        ({ period_unit, item_type, subscription_type, period }) =>
          period_unit === periodUnit &&
          item_type === "addon" &&
          subscription_type === type &&
          period === 1,
      ),
    [pricing, periodUnit, type],
  );

  const plan = useMemo(
    () =>
      pricing?.find(
        ({ period_unit, item_type, subscription_type, period }) =>
          period_unit === periodUnit &&
          item_type === "plan" &&
          subscription_type === type &&
          period === 1,
      ),
    [pricing, periodUnit, type],
  );

  return { plan, license, isLoadingPricing };
}
